"use strict";
export const validate = validate10;
export default validate10;
const schema11 = {
	type: "object",
	allOf: [{ $ref: "#/definitions/shoppingCartItem" }],
	properties: { subItems: { type: "array", items: { $ref: "#/definitions/shoppingCartItem" } } },
	definitions: {
		shoppingCartItem: {
			type: "object",
			$id: "ShoppingCartItem",
			properties: {
				id: {
					type: "string",
					title: "Shopping cart line ID",
					description:
						"Optional. Will be auto-generated if not set. If set, and matching a corresponding item, the item will be overwritten",
				},
				type: {
					type: "string",
					title: "Type",
					enum: [
						"hardware",
						"agreement",
						"subscription",
						"msisdn",
						"standalone",
						"mobile-subscription",
						"mobile-product",
						"old-swap-device",
						"delivery-details",
						"contact-information",
					],
				},
				data: { type: "object", properties: { id: { type: "string", title: "Product ID" } } },
				metadata: {
					type: "object",
					properties: {
						name: { title: "Name", type: "string" },
						description: { title: "Description", type: "string" },
						image: { type: "string", title: "URL to thumbnail image" },
						recurringPrice: { type: "number", title: "Recurring price" },
						price: { type: "number", title: "Price" },
						priceWithoutVat: { type: "number", title: "Price" },
						saleRecurringPrice: { type: "number", title: "Sale recurring price" },
						salePrice: { type: "number", title: "Sale price" },
						salePriceWithoutVat: { type: "number", title: "Sale price" },
					},
					required: ["name"],
					anyOf: [
						{ required: ["price"] },
						{ required: ["salePrice"] },
						{ required: ["recurringPrice"] },
						{ required: ["saleRecurringPrice"] },
					],
				},
			},
		},
	},
};
const schema12 = {
	type: "object",
	$id: "ShoppingCartItem",
	properties: {
		id: {
			type: "string",
			title: "Shopping cart line ID",
			description:
				"Optional. Will be auto-generated if not set. If set, and matching a corresponding item, the item will be overwritten",
		},
		type: {
			type: "string",
			title: "Type",
			enum: [
				"hardware",
				"agreement",
				"subscription",
				"msisdn",
				"standalone",
				"mobile-subscription",
				"mobile-product",
				"old-swap-device",
				"delivery-details",
				"contact-information",
			],
		},
		data: { type: "object", properties: { id: { type: "string", title: "Product ID" } } },
		metadata: {
			type: "object",
			properties: {
				name: { title: "Name", type: "string" },
				description: { title: "Description", type: "string" },
				image: { type: "string", title: "URL to thumbnail image" },
				recurringPrice: { type: "number", title: "Recurring price" },
				price: { type: "number", title: "Price" },
				priceWithoutVat: { type: "number", title: "Price" },
				saleRecurringPrice: { type: "number", title: "Sale recurring price" },
				salePrice: { type: "number", title: "Sale price" },
				salePriceWithoutVat: { type: "number", title: "Sale price" },
			},
			required: ["name"],
			anyOf: [
				{ required: ["price"] },
				{ required: ["salePrice"] },
				{ required: ["recurringPrice"] },
				{ required: ["saleRecurringPrice"] },
			],
		},
	},
};
function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
	let vErrors = null;
	let errors = 0;
	if (data && typeof data == "object" && !Array.isArray(data)) {
		if (data.id !== undefined) {
			if (typeof data.id !== "string") {
				const err0 = {
					instancePath: instancePath + "/id",
					schemaPath: "#/definitions/shoppingCartItem/properties/id/type",
					keyword: "type",
					params: { type: "string" },
					message: "must be string",
				};
				if (vErrors === null) {
					vErrors = [err0];
				} else {
					vErrors.push(err0);
				}
				errors++;
			}
		}
		if (data.type !== undefined) {
			let data1 = data.type;
			if (typeof data1 !== "string") {
				const err1 = {
					instancePath: instancePath + "/type",
					schemaPath: "#/definitions/shoppingCartItem/properties/type/type",
					keyword: "type",
					params: { type: "string" },
					message: "must be string",
				};
				if (vErrors === null) {
					vErrors = [err1];
				} else {
					vErrors.push(err1);
				}
				errors++;
			}
			if (
				!(
					data1 === "hardware" ||
					data1 === "agreement" ||
					data1 === "subscription" ||
					data1 === "msisdn" ||
					data1 === "standalone" ||
					data1 === "mobile-subscription" ||
					data1 === "mobile-product" ||
					data1 === "old-swap-device" ||
					data1 === "delivery-details" ||
					data1 === "contact-information"
				)
			) {
				const err2 = {
					instancePath: instancePath + "/type",
					schemaPath: "#/definitions/shoppingCartItem/properties/type/enum",
					keyword: "enum",
					params: { allowedValues: schema12.properties.type.enum },
					message: "must be equal to one of the allowed values",
				};
				if (vErrors === null) {
					vErrors = [err2];
				} else {
					vErrors.push(err2);
				}
				errors++;
			}
		}
		if (data.data !== undefined) {
			let data2 = data.data;
			if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
				if (data2.id !== undefined) {
					if (typeof data2.id !== "string") {
						const err3 = {
							instancePath: instancePath + "/data/id",
							schemaPath: "#/definitions/shoppingCartItem/properties/data/properties/id/type",
							keyword: "type",
							params: { type: "string" },
							message: "must be string",
						};
						if (vErrors === null) {
							vErrors = [err3];
						} else {
							vErrors.push(err3);
						}
						errors++;
					}
				}
			} else {
				const err4 = {
					instancePath: instancePath + "/data",
					schemaPath: "#/definitions/shoppingCartItem/properties/data/type",
					keyword: "type",
					params: { type: "object" },
					message: "must be object",
				};
				if (vErrors === null) {
					vErrors = [err4];
				} else {
					vErrors.push(err4);
				}
				errors++;
			}
		}
		if (data.metadata !== undefined) {
			let data4 = data.metadata;
			const _errs14 = errors;
			let valid4 = false;
			const _errs15 = errors;
			if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
				if (data4.price === undefined) {
					const err5 = {
						instancePath: instancePath + "/metadata",
						schemaPath: "#/definitions/shoppingCartItem/properties/metadata/anyOf/0/required",
						keyword: "required",
						params: { missingProperty: "price" },
						message: "must have required property '" + "price" + "'",
					};
					if (vErrors === null) {
						vErrors = [err5];
					} else {
						vErrors.push(err5);
					}
					errors++;
				}
			}
			var _valid0 = _errs15 === errors;
			valid4 = valid4 || _valid0;
			if (!valid4) {
				const _errs16 = errors;
				if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
					if (data4.salePrice === undefined) {
						const err6 = {
							instancePath: instancePath + "/metadata",
							schemaPath: "#/definitions/shoppingCartItem/properties/metadata/anyOf/1/required",
							keyword: "required",
							params: { missingProperty: "salePrice" },
							message: "must have required property '" + "salePrice" + "'",
						};
						if (vErrors === null) {
							vErrors = [err6];
						} else {
							vErrors.push(err6);
						}
						errors++;
					}
				}
				var _valid0 = _errs16 === errors;
				valid4 = valid4 || _valid0;
				if (!valid4) {
					const _errs17 = errors;
					if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
						if (data4.recurringPrice === undefined) {
							const err7 = {
								instancePath: instancePath + "/metadata",
								schemaPath: "#/definitions/shoppingCartItem/properties/metadata/anyOf/2/required",
								keyword: "required",
								params: { missingProperty: "recurringPrice" },
								message: "must have required property '" + "recurringPrice" + "'",
							};
							if (vErrors === null) {
								vErrors = [err7];
							} else {
								vErrors.push(err7);
							}
							errors++;
						}
					}
					var _valid0 = _errs17 === errors;
					valid4 = valid4 || _valid0;
					if (!valid4) {
						const _errs18 = errors;
						if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
							if (data4.saleRecurringPrice === undefined) {
								const err8 = {
									instancePath: instancePath + "/metadata",
									schemaPath: "#/definitions/shoppingCartItem/properties/metadata/anyOf/3/required",
									keyword: "required",
									params: { missingProperty: "saleRecurringPrice" },
									message: "must have required property '" + "saleRecurringPrice" + "'",
								};
								if (vErrors === null) {
									vErrors = [err8];
								} else {
									vErrors.push(err8);
								}
								errors++;
							}
						}
						var _valid0 = _errs18 === errors;
						valid4 = valid4 || _valid0;
					}
				}
			}
			if (!valid4) {
				const err9 = {
					instancePath: instancePath + "/metadata",
					schemaPath: "#/definitions/shoppingCartItem/properties/metadata/anyOf",
					keyword: "anyOf",
					params: {},
					message: "must match a schema in anyOf",
				};
				if (vErrors === null) {
					vErrors = [err9];
				} else {
					vErrors.push(err9);
				}
				errors++;
			} else {
				errors = _errs14;
				if (vErrors !== null) {
					if (_errs14) {
						vErrors.length = _errs14;
					} else {
						vErrors = null;
					}
				}
			}
			if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
				if (data4.name === undefined) {
					const err10 = {
						instancePath: instancePath + "/metadata",
						schemaPath: "#/definitions/shoppingCartItem/properties/metadata/required",
						keyword: "required",
						params: { missingProperty: "name" },
						message: "must have required property '" + "name" + "'",
					};
					if (vErrors === null) {
						vErrors = [err10];
					} else {
						vErrors.push(err10);
					}
					errors++;
				}
				if (data4.name !== undefined) {
					if (typeof data4.name !== "string") {
						const err11 = {
							instancePath: instancePath + "/metadata/name",
							schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/name/type",
							keyword: "type",
							params: { type: "string" },
							message: "must be string",
						};
						if (vErrors === null) {
							vErrors = [err11];
						} else {
							vErrors.push(err11);
						}
						errors++;
					}
				}
				if (data4.description !== undefined) {
					if (typeof data4.description !== "string") {
						const err12 = {
							instancePath: instancePath + "/metadata/description",
							schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/description/type",
							keyword: "type",
							params: { type: "string" },
							message: "must be string",
						};
						if (vErrors === null) {
							vErrors = [err12];
						} else {
							vErrors.push(err12);
						}
						errors++;
					}
				}
				if (data4.image !== undefined) {
					if (typeof data4.image !== "string") {
						const err13 = {
							instancePath: instancePath + "/metadata/image",
							schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/image/type",
							keyword: "type",
							params: { type: "string" },
							message: "must be string",
						};
						if (vErrors === null) {
							vErrors = [err13];
						} else {
							vErrors.push(err13);
						}
						errors++;
					}
				}
				if (data4.recurringPrice !== undefined) {
					let data8 = data4.recurringPrice;
					if (!(typeof data8 == "number" && isFinite(data8))) {
						const err14 = {
							instancePath: instancePath + "/metadata/recurringPrice",
							schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/recurringPrice/type",
							keyword: "type",
							params: { type: "number" },
							message: "must be number",
						};
						if (vErrors === null) {
							vErrors = [err14];
						} else {
							vErrors.push(err14);
						}
						errors++;
					}
				}
				if (data4.price !== undefined) {
					let data9 = data4.price;
					if (!(typeof data9 == "number" && isFinite(data9))) {
						const err15 = {
							instancePath: instancePath + "/metadata/price",
							schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/price/type",
							keyword: "type",
							params: { type: "number" },
							message: "must be number",
						};
						if (vErrors === null) {
							vErrors = [err15];
						} else {
							vErrors.push(err15);
						}
						errors++;
					}
				}
				if (data4.priceWithoutVat !== undefined) {
					let data10 = data4.priceWithoutVat;
					if (!(typeof data10 == "number" && isFinite(data10))) {
						const err16 = {
							instancePath: instancePath + "/metadata/priceWithoutVat",
							schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/priceWithoutVat/type",
							keyword: "type",
							params: { type: "number" },
							message: "must be number",
						};
						if (vErrors === null) {
							vErrors = [err16];
						} else {
							vErrors.push(err16);
						}
						errors++;
					}
				}
				if (data4.saleRecurringPrice !== undefined) {
					let data11 = data4.saleRecurringPrice;
					if (!(typeof data11 == "number" && isFinite(data11))) {
						const err17 = {
							instancePath: instancePath + "/metadata/saleRecurringPrice",
							schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/saleRecurringPrice/type",
							keyword: "type",
							params: { type: "number" },
							message: "must be number",
						};
						if (vErrors === null) {
							vErrors = [err17];
						} else {
							vErrors.push(err17);
						}
						errors++;
					}
				}
				if (data4.salePrice !== undefined) {
					let data12 = data4.salePrice;
					if (!(typeof data12 == "number" && isFinite(data12))) {
						const err18 = {
							instancePath: instancePath + "/metadata/salePrice",
							schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/salePrice/type",
							keyword: "type",
							params: { type: "number" },
							message: "must be number",
						};
						if (vErrors === null) {
							vErrors = [err18];
						} else {
							vErrors.push(err18);
						}
						errors++;
					}
				}
				if (data4.salePriceWithoutVat !== undefined) {
					let data13 = data4.salePriceWithoutVat;
					if (!(typeof data13 == "number" && isFinite(data13))) {
						const err19 = {
							instancePath: instancePath + "/metadata/salePriceWithoutVat",
							schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/salePriceWithoutVat/type",
							keyword: "type",
							params: { type: "number" },
							message: "must be number",
						};
						if (vErrors === null) {
							vErrors = [err19];
						} else {
							vErrors.push(err19);
						}
						errors++;
					}
				}
			} else {
				const err20 = {
					instancePath: instancePath + "/metadata",
					schemaPath: "#/definitions/shoppingCartItem/properties/metadata/type",
					keyword: "type",
					params: { type: "object" },
					message: "must be object",
				};
				if (vErrors === null) {
					vErrors = [err20];
				} else {
					vErrors.push(err20);
				}
				errors++;
			}
		}
	} else {
		const err21 = {
			instancePath,
			schemaPath: "#/definitions/shoppingCartItem/type",
			keyword: "type",
			params: { type: "object" },
			message: "must be object",
		};
		if (vErrors === null) {
			vErrors = [err21];
		} else {
			vErrors.push(err21);
		}
		errors++;
	}
	if (data && typeof data == "object" && !Array.isArray(data)) {
		if (data.subItems !== undefined) {
			let data14 = data.subItems;
			if (Array.isArray(data14)) {
				const len0 = data14.length;
				for (let i0 = 0; i0 < len0; i0++) {
					let data15 = data14[i0];
					if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
						if (data15.id !== undefined) {
							if (typeof data15.id !== "string") {
								const err22 = {
									instancePath: instancePath + "/subItems/" + i0 + "/id",
									schemaPath: "#/definitions/shoppingCartItem/properties/id/type",
									keyword: "type",
									params: { type: "string" },
									message: "must be string",
								};
								if (vErrors === null) {
									vErrors = [err22];
								} else {
									vErrors.push(err22);
								}
								errors++;
							}
						}
						if (data15.type !== undefined) {
							let data17 = data15.type;
							if (typeof data17 !== "string") {
								const err23 = {
									instancePath: instancePath + "/subItems/" + i0 + "/type",
									schemaPath: "#/definitions/shoppingCartItem/properties/type/type",
									keyword: "type",
									params: { type: "string" },
									message: "must be string",
								};
								if (vErrors === null) {
									vErrors = [err23];
								} else {
									vErrors.push(err23);
								}
								errors++;
							}
							if (
								!(
									data17 === "hardware" ||
									data17 === "agreement" ||
									data17 === "subscription" ||
									data17 === "msisdn" ||
									data17 === "standalone" ||
									data17 === "mobile-subscription" ||
									data17 === "mobile-product" ||
									data17 === "old-swap-device" ||
									data17 === "delivery-details" ||
									data17 === "contact-information"
								)
							) {
								const err24 = {
									instancePath: instancePath + "/subItems/" + i0 + "/type",
									schemaPath: "#/definitions/shoppingCartItem/properties/type/enum",
									keyword: "enum",
									params: { allowedValues: schema12.properties.type.enum },
									message: "must be equal to one of the allowed values",
								};
								if (vErrors === null) {
									vErrors = [err24];
								} else {
									vErrors.push(err24);
								}
								errors++;
							}
						}
						if (data15.data !== undefined) {
							let data18 = data15.data;
							if (data18 && typeof data18 == "object" && !Array.isArray(data18)) {
								if (data18.id !== undefined) {
									if (typeof data18.id !== "string") {
										const err25 = {
											instancePath: instancePath + "/subItems/" + i0 + "/data/id",
											schemaPath: "#/definitions/shoppingCartItem/properties/data/properties/id/type",
											keyword: "type",
											params: { type: "string" },
											message: "must be string",
										};
										if (vErrors === null) {
											vErrors = [err25];
										} else {
											vErrors.push(err25);
										}
										errors++;
									}
								}
							} else {
								const err26 = {
									instancePath: instancePath + "/subItems/" + i0 + "/data",
									schemaPath: "#/definitions/shoppingCartItem/properties/data/type",
									keyword: "type",
									params: { type: "object" },
									message: "must be object",
								};
								if (vErrors === null) {
									vErrors = [err26];
								} else {
									vErrors.push(err26);
								}
								errors++;
							}
						}
						if (data15.metadata !== undefined) {
							let data20 = data15.metadata;
							const _errs52 = errors;
							let valid12 = false;
							const _errs53 = errors;
							if (data20 && typeof data20 == "object" && !Array.isArray(data20)) {
								if (data20.price === undefined) {
									const err27 = {
										instancePath: instancePath + "/subItems/" + i0 + "/metadata",
										schemaPath: "#/definitions/shoppingCartItem/properties/metadata/anyOf/0/required",
										keyword: "required",
										params: { missingProperty: "price" },
										message: "must have required property '" + "price" + "'",
									};
									if (vErrors === null) {
										vErrors = [err27];
									} else {
										vErrors.push(err27);
									}
									errors++;
								}
							}
							var _valid1 = _errs53 === errors;
							valid12 = valid12 || _valid1;
							if (!valid12) {
								const _errs54 = errors;
								if (data20 && typeof data20 == "object" && !Array.isArray(data20)) {
									if (data20.salePrice === undefined) {
										const err28 = {
											instancePath: instancePath + "/subItems/" + i0 + "/metadata",
											schemaPath: "#/definitions/shoppingCartItem/properties/metadata/anyOf/1/required",
											keyword: "required",
											params: { missingProperty: "salePrice" },
											message: "must have required property '" + "salePrice" + "'",
										};
										if (vErrors === null) {
											vErrors = [err28];
										} else {
											vErrors.push(err28);
										}
										errors++;
									}
								}
								var _valid1 = _errs54 === errors;
								valid12 = valid12 || _valid1;
								if (!valid12) {
									const _errs55 = errors;
									if (data20 && typeof data20 == "object" && !Array.isArray(data20)) {
										if (data20.recurringPrice === undefined) {
											const err29 = {
												instancePath: instancePath + "/subItems/" + i0 + "/metadata",
												schemaPath: "#/definitions/shoppingCartItem/properties/metadata/anyOf/2/required",
												keyword: "required",
												params: { missingProperty: "recurringPrice" },
												message: "must have required property '" + "recurringPrice" + "'",
											};
											if (vErrors === null) {
												vErrors = [err29];
											} else {
												vErrors.push(err29);
											}
											errors++;
										}
									}
									var _valid1 = _errs55 === errors;
									valid12 = valid12 || _valid1;
									if (!valid12) {
										const _errs56 = errors;
										if (data20 && typeof data20 == "object" && !Array.isArray(data20)) {
											if (data20.saleRecurringPrice === undefined) {
												const err30 = {
													instancePath: instancePath + "/subItems/" + i0 + "/metadata",
													schemaPath: "#/definitions/shoppingCartItem/properties/metadata/anyOf/3/required",
													keyword: "required",
													params: { missingProperty: "saleRecurringPrice" },
													message: "must have required property '" + "saleRecurringPrice" + "'",
												};
												if (vErrors === null) {
													vErrors = [err30];
												} else {
													vErrors.push(err30);
												}
												errors++;
											}
										}
										var _valid1 = _errs56 === errors;
										valid12 = valid12 || _valid1;
									}
								}
							}
							if (!valid12) {
								const err31 = {
									instancePath: instancePath + "/subItems/" + i0 + "/metadata",
									schemaPath: "#/definitions/shoppingCartItem/properties/metadata/anyOf",
									keyword: "anyOf",
									params: {},
									message: "must match a schema in anyOf",
								};
								if (vErrors === null) {
									vErrors = [err31];
								} else {
									vErrors.push(err31);
								}
								errors++;
							} else {
								errors = _errs52;
								if (vErrors !== null) {
									if (_errs52) {
										vErrors.length = _errs52;
									} else {
										vErrors = null;
									}
								}
							}
							if (data20 && typeof data20 == "object" && !Array.isArray(data20)) {
								if (data20.name === undefined) {
									const err32 = {
										instancePath: instancePath + "/subItems/" + i0 + "/metadata",
										schemaPath: "#/definitions/shoppingCartItem/properties/metadata/required",
										keyword: "required",
										params: { missingProperty: "name" },
										message: "must have required property '" + "name" + "'",
									};
									if (vErrors === null) {
										vErrors = [err32];
									} else {
										vErrors.push(err32);
									}
									errors++;
								}
								if (data20.name !== undefined) {
									if (typeof data20.name !== "string") {
										const err33 = {
											instancePath: instancePath + "/subItems/" + i0 + "/metadata/name",
											schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/name/type",
											keyword: "type",
											params: { type: "string" },
											message: "must be string",
										};
										if (vErrors === null) {
											vErrors = [err33];
										} else {
											vErrors.push(err33);
										}
										errors++;
									}
								}
								if (data20.description !== undefined) {
									if (typeof data20.description !== "string") {
										const err34 = {
											instancePath: instancePath + "/subItems/" + i0 + "/metadata/description",
											schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/description/type",
											keyword: "type",
											params: { type: "string" },
											message: "must be string",
										};
										if (vErrors === null) {
											vErrors = [err34];
										} else {
											vErrors.push(err34);
										}
										errors++;
									}
								}
								if (data20.image !== undefined) {
									if (typeof data20.image !== "string") {
										const err35 = {
											instancePath: instancePath + "/subItems/" + i0 + "/metadata/image",
											schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/image/type",
											keyword: "type",
											params: { type: "string" },
											message: "must be string",
										};
										if (vErrors === null) {
											vErrors = [err35];
										} else {
											vErrors.push(err35);
										}
										errors++;
									}
								}
								if (data20.recurringPrice !== undefined) {
									let data24 = data20.recurringPrice;
									if (!(typeof data24 == "number" && isFinite(data24))) {
										const err36 = {
											instancePath: instancePath + "/subItems/" + i0 + "/metadata/recurringPrice",
											schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/recurringPrice/type",
											keyword: "type",
											params: { type: "number" },
											message: "must be number",
										};
										if (vErrors === null) {
											vErrors = [err36];
										} else {
											vErrors.push(err36);
										}
										errors++;
									}
								}
								if (data20.price !== undefined) {
									let data25 = data20.price;
									if (!(typeof data25 == "number" && isFinite(data25))) {
										const err37 = {
											instancePath: instancePath + "/subItems/" + i0 + "/metadata/price",
											schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/price/type",
											keyword: "type",
											params: { type: "number" },
											message: "must be number",
										};
										if (vErrors === null) {
											vErrors = [err37];
										} else {
											vErrors.push(err37);
										}
										errors++;
									}
								}
								if (data20.priceWithoutVat !== undefined) {
									let data26 = data20.priceWithoutVat;
									if (!(typeof data26 == "number" && isFinite(data26))) {
										const err38 = {
											instancePath: instancePath + "/subItems/" + i0 + "/metadata/priceWithoutVat",
											schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/priceWithoutVat/type",
											keyword: "type",
											params: { type: "number" },
											message: "must be number",
										};
										if (vErrors === null) {
											vErrors = [err38];
										} else {
											vErrors.push(err38);
										}
										errors++;
									}
								}
								if (data20.saleRecurringPrice !== undefined) {
									let data27 = data20.saleRecurringPrice;
									if (!(typeof data27 == "number" && isFinite(data27))) {
										const err39 = {
											instancePath: instancePath + "/subItems/" + i0 + "/metadata/saleRecurringPrice",
											schemaPath:
												"#/definitions/shoppingCartItem/properties/metadata/properties/saleRecurringPrice/type",
											keyword: "type",
											params: { type: "number" },
											message: "must be number",
										};
										if (vErrors === null) {
											vErrors = [err39];
										} else {
											vErrors.push(err39);
										}
										errors++;
									}
								}
								if (data20.salePrice !== undefined) {
									let data28 = data20.salePrice;
									if (!(typeof data28 == "number" && isFinite(data28))) {
										const err40 = {
											instancePath: instancePath + "/subItems/" + i0 + "/metadata/salePrice",
											schemaPath: "#/definitions/shoppingCartItem/properties/metadata/properties/salePrice/type",
											keyword: "type",
											params: { type: "number" },
											message: "must be number",
										};
										if (vErrors === null) {
											vErrors = [err40];
										} else {
											vErrors.push(err40);
										}
										errors++;
									}
								}
								if (data20.salePriceWithoutVat !== undefined) {
									let data29 = data20.salePriceWithoutVat;
									if (!(typeof data29 == "number" && isFinite(data29))) {
										const err41 = {
											instancePath: instancePath + "/subItems/" + i0 + "/metadata/salePriceWithoutVat",
											schemaPath:
												"#/definitions/shoppingCartItem/properties/metadata/properties/salePriceWithoutVat/type",
											keyword: "type",
											params: { type: "number" },
											message: "must be number",
										};
										if (vErrors === null) {
											vErrors = [err41];
										} else {
											vErrors.push(err41);
										}
										errors++;
									}
								}
							} else {
								const err42 = {
									instancePath: instancePath + "/subItems/" + i0 + "/metadata",
									schemaPath: "#/definitions/shoppingCartItem/properties/metadata/type",
									keyword: "type",
									params: { type: "object" },
									message: "must be object",
								};
								if (vErrors === null) {
									vErrors = [err42];
								} else {
									vErrors.push(err42);
								}
								errors++;
							}
						}
					} else {
						const err43 = {
							instancePath: instancePath + "/subItems/" + i0,
							schemaPath: "#/definitions/shoppingCartItem/type",
							keyword: "type",
							params: { type: "object" },
							message: "must be object",
						};
						if (vErrors === null) {
							vErrors = [err43];
						} else {
							vErrors.push(err43);
						}
						errors++;
					}
				}
			} else {
				const err44 = {
					instancePath: instancePath + "/subItems",
					schemaPath: "#/properties/subItems/type",
					keyword: "type",
					params: { type: "array" },
					message: "must be array",
				};
				if (vErrors === null) {
					vErrors = [err44];
				} else {
					vErrors.push(err44);
				}
				errors++;
			}
		}
	} else {
		const err45 = {
			instancePath,
			schemaPath: "#/type",
			keyword: "type",
			params: { type: "object" },
			message: "must be object",
		};
		if (vErrors === null) {
			vErrors = [err45];
		} else {
			vErrors.push(err45);
		}
		errors++;
	}
	validate10.errors = vErrors;
	return errors === 0;
}
